// @vendors
const React = require('react');
const PropTypes = require('prop-types');


require('./brokerRiskIndicator.scss');

const RiskNumbers = ({ riskValue, liquidity }) => {
    const classForLanding = liquidity ? "broker-risk-indicator-risk-numbers__number--not-selected-liquidity"
                            : "broker-risk-indicator-risk-numbers__number--not-selected"
    const content = [1, 2, 3, 4, 5, 6, 7]
        .filter( pos => pos >= 1 & pos <= 7)
        .map( i =>
            riskValue === 0 ?
                <span className={classForLanding} key={i}>{i}</span>
                : riskValue !== i?
                    <span className="broker-risk-indicator-risk-numbers__number" key={i}>{i}</span>
                    : <span className="broker-risk-indicator-risk-numbers__number--selected" key={i}>{i}</span>
        );

    return (
        !!content ? <div className="broker-risk-indicator-risk-numbers__block"> {content} </div>: null
    );
}

RiskNumbers.propTypes = {
    riskValue: PropTypes.number,
    liquidity: PropTypes.bool
}

RiskNumbers.defaultProps = {
    riskValue: 0,
    liquidity: false,
}

module.exports = RiskNumbers;